var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDidAvatarLine = function SvgDidAvatarLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 530 175"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265 174.351C169.2 174.351 73.3991 137.934 0.236328 64.7712C11.7193 34.5875 36.9817 9.65311 70.7744 0.138672C124.908 52.6321 194.79 78.8789 265 78.8789C335.21 78.8789 405.092 52.6321 459.226 0.138672C493.019 9.65311 518.281 34.2594 529.764 64.7712C456.929 137.606 360.801 174.351 265 174.351Z"
  })));
};
export default SvgDidAvatarLine;